












































































































































































































import Vue from 'vue';
import axios from 'axios';
import _ from 'lodash';

import Requester from '../../requester';

import { estadosBrasilItems } from '../../utils/constants';

import { Paciente } from '../../../../back/src/entity/Paciente';

import Carregando from '../Carregando.vue';
import Confirmar from '../Confirmar.vue';
import { PacientePutFormData } from '../../../../back/src/types';

export default Vue.extend({
  name: 'ThePacientesCadastroInternoEndereco',
  components: {
    Carregando,
    Confirmar,
  },
  props: {
    paciente: {
      type: Object as () => Paciente,
      default: {} as Paciente,
    },
  },
  data() {
    return {
      loading: {
        form: false,
        cep: false,
        submit: false,
      },
      valid: false,
      validInternacional: false,
      cepInvalido: false,
      cepHint: '',
      cepUltimaBusca: '',
      paisBrasil: true,
      formLock: {
        logradouro: true,
        bairro: true,
        cidade: true,
        estado: true,
      },
      form: {
        cep: '',
        logradouro: '',
        numero: '',
        complemento: '',
        bairro: '',
        cidade: '',
        estado: '',
        pais: 'Brasil',
      },
      formInternacional: {
        cep: '',
        logradouro: '',
        numero: '',
        complemento: '',
        bairro: '',
        cidade: '',
        estado: 'EX',
        pais: '',
      },
      errorMessages: {
        cep: [] as string[],
      },
      rules: {
        required: [
          (v: string) => !!v || 'Campo obrigatório',
        ],
      },
      items: {
        estado: estadosBrasilItems,
      },
    };
  },
  computed: {
    confirmar(): Vue & { open: (titulo: string, mensagem: string) => boolean } {
      return this.$refs.confirmar as Vue & { open: (titulo: string, mensagem: string) => boolean };
    },
    classActions(): string {
      if (this.$vuetify.breakpoint.xsOnly) {
        return 'd-flex justify-space-between pt-0 pb-2';
      }
      return 'd-flex justify-end pt-0 pb-2';
    },
    formEndereco(): Vue & { validate: () => boolean, resetValidation: () => void } {
      return this.$refs.formEndereco as Vue & {
        validate: () => boolean,
        resetValidation: () => void
      };
    },
    formInternacionalEndereco(): Vue & { validate: () => boolean, resetValidation: () => void } {
      return this.$refs.formInternacionalEndereco as Vue & {
        validate: () => boolean,
        resetValidation: () => void
      };
    },
    axiosInstanceCep() {
      const instance = axios.create();
      instance.defaults.headers.common = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      };
      return instance;
    },
  },
  watch: {
    // eslint-disable-next-line func-names
    'formInternacional.pais': function (val) {
      if (_.lowerCase(val) === 'brasil' || _.lowerCase(val) === 'brazil') {
        this.paisBrasil = true;
        this.$set(this.formInternacional, 'pais', '');
        this.$set(this.form, 'pais', 'Brasil');
      }
    },
  },
  methods: {
    preencheForm() {
      this.loading.form = true;
      if (!_.isEmpty(this.paciente) && !!this.paciente.cep) {
        if (this.paciente.estado === 'EX') {
          this.paisBrasil = false;
          this.form.cep = '';
          this.form.logradouro = '';
          this.form.numero = '';
          this.form.complemento = '';
          this.form.bairro = '';
          this.form.cidade = '';
          this.form.estado = '';
          this.form.pais = 'Brasil';
          this.formInternacional.cep = this.paciente.cep;
          this.formInternacional.logradouro = this.paciente.logradouro;
          this.formInternacional.numero = this.paciente.numero;
          this.formInternacional.complemento = this.paciente.complemento;
          this.formInternacional.bairro = this.paciente.bairro;
          this.formInternacional.cidade = this.paciente.cidade;
          this.formInternacional.estado = this.paciente.estado;
          this.formInternacional.pais = this.paciente.pais;
        } else {
          this.paisBrasil = true;
          this.form.cep = this.paciente.cep;
          this.form.logradouro = this.paciente.logradouro;
          this.form.numero = this.paciente.numero;
          this.form.complemento = this.paciente.complemento;
          this.form.bairro = this.paciente.bairro;
          this.form.cidade = this.paciente.cidade;
          this.form.estado = this.paciente.estado;
          this.form.pais = this.paciente.pais;
          this.formInternacional.cep = '';
          this.formInternacional.logradouro = '';
          this.formInternacional.numero = '';
          this.formInternacional.complemento = '';
          this.formInternacional.bairro = '';
          this.formInternacional.cidade = '';
          this.formInternacional.estado = 'EX';
          this.formInternacional.pais = '';
        }
      }
      this.loading.form = false;
    },
    // eslint-disable-next-line func-names
    buscaCepDebounce: _.debounce(async function () { await this.buscaCep(); }, 200),
    async buscaCep() {
      if (this.form.cep.length === 0 || !this.form.cep) {
        this.resetEndereco();
        this.lockEndereco();
        return;
      }
      if (this.form.cep.length !== 9) {
        return;
      }
      const cep: string = this.form.cep.replace('-', '');
      // if (cep === this.cepUltimaBusca) {
      //   return;
      // }
      this.cepHint = '';
      // this.cepUltimaBusca = cep;
      this.loading.cep = true;
      try {
        const response = await this.axiosInstanceCep.get(`https://viacep.com.br/ws/${cep}/json/`);
        if (!response.data.erro) {
          // this.cepUltimaBusca = cep;
          this.form.logradouro = response.data.logradouro;
          this.form.bairro = response.data.bairro;
          this.form.cidade = response.data.localidade;
          this.form.estado = response.data.uf;
        } else {
          this.resetEndereco();
          this.cepHint = 'CEP não encontrado!';
          this.formEtapa3.resetValidation();
        }
        // destrava campos vazios
        this.enderecoLockCheck();
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.cep = false;
      }
    },
    resetEndereco() {
      this.form.logradouro = null;
      this.form.bairro = null;
      this.form.cidade = null;
      this.form.estado = null;
    },
    lockEndereco() {
      this.formLock.logradouro = true;
      this.formLock.bairro = true;
      this.formLock.cidade = true;
      this.formLock.estado = true;
    },
    enderecoLockCheck() {
      if (!this.form.logradouro) this.formLock.logradouro = false;
      if (!this.form.bairro) this.formLock.bairro = false;
      if (!this.form.cidade) this.formLock.cidade = false;
      if (!this.form.estado) this.formLock.estado = false;
    },
    // eslint-disable-next-line func-names
    desfazerDebounce: _.debounce(async function () { await this.desfazer(); }, 200),
    async desfazer() {
      if (await this.confirmar.open(
        'Desfazer edição',
        'Tem certeza que deseja desfazer a edição?\nOs dados alterados serão perdidos.',
      ) === false) {
        return;
      }
      this.$emit('desfazer');
      this.formEndereco.resetValidation();
      this.formInternacionalEndereco.resetValidation();
      this.preencheForm();
    },
    // eslint-disable-next-line func-names
    submitFormDebounce: _.debounce(async function () { await this.submitForm(); }, 200),
    async submitForm() {
      this.loading.submit = true;
      const formData: PacientePutFormData = {
        id: this.paciente.id,
      };
      if (this.paisBrasil) {
        if (!this.formEndereco.validate()) {
          this.loading.submit = false;
          return;
        }
        _.assign(formData, {
          cep: this.form.cep,
          logradouro: this.form.logradouro,
          numero: this.form.numero,
          complemento: this.form.complemento,
          bairro: this.form.bairro,
          cidade: this.form.cidade,
          estado: this.form.estado,
          pais: this.form.pais,
        });
      } else {
        if (!this.formInternacionalEndereco.validate()) {
          this.loading.submit = false;
          return;
        }
        _.assign(formData, {
          id: this.paciente.id,
          cep: this.formInternacional.cep,
          logradouro: this.formInternacional.logradouro,
          numero: this.formInternacional.numero,
          complemento: this.formInternacional.complemento,
          bairro: this.formInternacional.bairro,
          cidade: this.formInternacional.cidade,
          estado: this.formInternacional.estado,
          pais: this.formInternacional.pais,
        });
      }
      try {
        const response = await Requester.paciente.alteraPaciente(formData);
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.$emit('atualizaPaciente', response.data);
          this.$root.$emit('avisoSnackbar', {
            color: 'success',
            text: 'Paciente atualizada com sucesso!',
          });
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.submit = false;
      }
    },
  },
});
